/**
 * The group copy's clipboard as React state: what is copied now, kept in
 * step with a copy or a clear made on this page, in another tab, or on
 * another country's board.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useEffect, useState } from 'react';

import { CLIP_EVENT, CLIP_STORAGE_KEY, clearClip, type GroupCopyClip, readClip, writeClip } from './group-copy-clipboard';

export function useGroupCopyClipboard() {
  const [clip, setClip] = useState<GroupCopyClip | null>(readClip);
  useEffect(() => {
    const sync = () => setClip(readClip());
    const fromOtherTab = (e: StorageEvent) => (e.key === null || e.key === CLIP_STORAGE_KEY) && sync();
    window.addEventListener(CLIP_EVENT, sync);
    window.addEventListener('storage', fromOtherTab);
    return () => {
      window.removeEventListener(CLIP_EVENT, sync);
      window.removeEventListener('storage', fromOtherTab);
    };
  }, []);
  return { clip, copy: writeClip, clear: clearClip };
}
